import React, { Component } from 'react';
import {observer} from "mobx-react"
import SortieStore from "../SortieStore"
import axios from "axios"
import { HashRouter as Router, Route, Link } from "react-router-dom";
import Pictures from "./Pictures"
var _ = require('lodash');


@observer
export default class Compteurs extends React.Component {
  constructor(props) {
    super(props);
    this.loadRecapitulatif = this.loadRecapitulatif.bind(this)
    this.titre_compteureau = this.titre_compteureau.bind(this)
    this.valeur_compteureau = this.valeur_compteureau.bind(this)
    this.valeur_compteureauchaude = this.valeur_compteureauchaude.bind(this)
    this.valeur_compteureaufroide = this.valeur_compteureaufroide.bind(this)
    this.titre_compteureauchaude = this.titre_compteureauchaude.bind(this)
    this.titre_compteureaufroide = this.titre_compteureaufroide.bind(this)
    this.titre_compteurgaz = this.titre_compteurgaz.bind(this)
    this.valeur_compteurgaz = this.valeur_compteurgaz.bind(this)
    this.valeur_electricite = this.valeur_electricite.bind(this)
    this.titre_electricite = this.titre_electricite.bind(this)
    this.update = _.debounce(this.update.bind(this), 800)
    this.state = {
      bien: {
        compteureau: "",
        compteureaufroide: "",
        compteureauchaude: "",
        compteurelectricite: "",
        compteurgaz: ""
      },
      sortie: {
        compteureau: "",
        compteureaufroide: "",
        compteureauchaude: "",
        compteurelectricite: "",
        compteurgaz: ""
      }
    };
    this.loadRecapitulatif()
  }
  componentDidMount(){
    SortieStore.showPDF = false
  }
  componentWillUnmount(){
    SortieStore.showPDF = true
  }
  loadRecapitulatif(){
    axios.post("/api/v1/experts/app/sortie/compteurs",{id: SortieStore.rdv.id}).then((data)=>{
      this.setState(data.data)
    })
  }
  titre_compteureau(e){
    let bien = this.state.bien
    bien.compteureau = e.target.value
    this.setState({bien: bien})
    this.update()
  }
  titre_compteureaufroide(e){
    let bien = this.state.bien
    bien.compteureaufroide = e.target.value
    this.setState({bien: bien})
    this.update()

  }
  titre_compteureauchaude(e){
    let bien = this.state.bien
    bien.compteureauchaude = e.target.value
    this.setState({bien: bien})
    this.update()

  }
  titre_electricite(e){
    let bien = this.state.bien
    bien.compteurelectricite = e.target.value
    this.setState({bien: bien})
    this.update()

  }
  titre_compteurgaz(e){
    let bien = this.state.bien
    bien.compteurgaz = e.target.value
    this.setState({bien: bien})
    this.update()

  }
  valeur_compteureau(e){
    let sortie = this.state.sortie
    sortie.compteureau = e.target.value
    this.setState({sortie: sortie})
    this.update()

  }
  valeur_compteureauchaude(e){
    let sortie = this.state.sortie
    sortie.compteureauchaude = e.target.value
    this.setState({sortie: sortie})
    this.update()

  }
  valeur_compteureaufroide(e){
    let sortie = this.state.sortie
    sortie.compteureaufroide = e.target.value
    this.setState({sortie: sortie})
    this.update()

  }
  valeur_electricite(e){
    let sortie = this.state.sortie
    sortie.compteurelectricite = e.target.value
    this.setState({sortie: sortie})
    this.update()

  }
  valeur_compteurgaz(e){
    let sortie = this.state.sortie
    sortie.compteurgaz = e.target.value
    this.setState({sortie: sortie})
    this.update()

  }

  update(){
    axios.post("/api/v1/experts/app/sortie/updateCompteurs",{id: SortieStore.rdv.id,bien: this.state.bien,sortie: this.state.sortie}).then((data)=>{
      console.log("updated")
    })
  }
  render() {
    if(SortieStore.loaded){

      return(
        <div className="container">
          <h1 className="center">Compteurs</h1>
          <div className="row">
            <div className="col s2">
              Compteur eau
            </div>
            <div className="col s4">
              <input type="text" onChange={this.titre_compteureau} value={this.state.bien.compteureau} />
              <label className="active" htmlFor="text">Numéro de compteur</label>
            </div>
            <div className="col s4">
              <input type="text" onChange={this.valeur_compteureau} value={this.state.sortie.compteureau} />
              <label className="active" htmlFor="text">Valeur du compteur</label>
            </div>
          </div>

          <div className="row">
            <div className="col s2">
              Compteur eau froide
            </div>
            <div className="col s4">
              <input type="text" onChange={this.titre_compteureaufroide} value={this.state.bien.compteureaufroide} />
              <label className="active" htmlFor="text">Numéro de compteur</label>
            </div>
            <div className="col s4">
              <input type="text" onChange={this.valeur_compteureaufroide} value={this.state.sortie.compteureaufroide} />
              <label className="active" htmlFor="text">Valeur du compteur</label>
            </div>
          </div>

          <div className="row">
            <div className="col s2">
              Compteur eau chaude
            </div>
            <div className="col s4">
              <input type="text" onChange={this.titre_compteureauchaude} value={this.state.bien.compteureauchaude} />
              <label className="active" htmlFor="text">Numéro de compteur</label>
            </div>
            <div className="col s4">
              <input type="text" onChange={this.valeur_compteureauchaude} value={this.state.sortie.compteureauchaude} />
              <label className="active" htmlFor="text">Valeur du compteur</label>
            </div>
          </div>
          <div className="row">
            <div className="col s2">
              Compteur gaz
            </div>
            <div className="col s4">
              <input type="text" onChange={this.titre_compteurgaz} value={this.state.bien.compteurgaz} />
              <label className="active" htmlFor="text">Numéro de compteur</label>
            </div>
            <div className="col s4">
              <input type="text" onChange={this.valeur_compteurgaz} value={this.state.sortie.compteurgaz} />
              <label className="active" htmlFor="text">Valeur du compteur</label>
            </div>
          </div>
          <div className="row">
            <div className="col s2">
              Compteur Electricité
            </div>
            <div className="col s4">
              <input type="text" onChange={this.titre_electricite} value={this.state.bien.compteurelectricite} />
              <label className="active" htmlFor="text">Numéro de compteur</label>
            </div>
            <div className="col s4">
              <input type="text" onChange={this.valeur_electricite} value={this.state.sortie.compteurelectricite} />
              <label className="active" htmlFor="text">Valeur du compteur</label>
            </div>
          </div>
          <Pictures/>
        </div>
        )
    }else{
     return (
        <div>
        Chargement en cours
        </div>
      );
   }
  }
}


